import React, { useEffect } from "react";
import { NotificationAlertContext } from "../../contexts/notificationAlertContext.js";
import { useHistory, useParams } from "react-router-dom";

import { API, graphqlOperation } from "aws-amplify";
import _ from "lodash";

import {
  getArchivedMessageManifest,
  invokeMCTask,
} from "../../graphql/queries.js";
// react-bootstrap components
import {
  Container,
  Card,
  Row,
  Col,
  Table,
  OverlayTrigger,
  Tooltip,
  Button,
  Spinner,
} from "react-bootstrap";

import { Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import Chat from "views/Components/Chat.js";
import { tourGuideSteps } from "views/Components/ViewMessageSteps.js";
import { AuthContext } from "contexts/authContext.js";
import { useTour } from "@reactour/tour";
import { convertDateToLocaleString } from "utilities/dateUtilities.js";

const ViewMessage = (props) => {
  // Contexts
  const notify = React.useContext(NotificationAlertContext);
  const currentUser = React.useContext(AuthContext);
  const history = useHistory();

  // Get manifestId
  let { manifestId } = useParams();
  manifestId = manifestId.split("?")[0];

  const searchParams = new URLSearchParams(window.location.search);

  const clientId = searchParams.get("clientId");
  const clientEnvironmentId = searchParams.get("clientEnvironmentId");
  const channelId = searchParams.get("channelId");
  const messageId = searchParams.get("messageId");
  const dateRollup = searchParams.get("dateRollup");

  // Tour Guide
  const { setIsOpen, setCurrentStep, setSteps } = useTour();

  // SSO related information
  const clientName = props.location.state?.clientName;
  const channelName = props.location.state?.channelName;
  const clientEnvironmentName = props.location.state?.clientEnvironmentName;

  const [manifestDetails, setManifestDetails] = React.useState({
    environment_id: "",
    channel_id: "",
    manifest_id: "",
    msg_id: 0,
    sent_total: 0,
    error_total: 0,
    filter_total: 0,
    raw_message_bytes: 0.0,
    date_received: "",
    date_completed: "",
    date_rollup: "",
    archive_bundle_path: "",
    message_bundle_details: null,
    flat_message_details: null,
    raw_data: {},
  });

  const [connectorData, setConnectorData] = React.useState([]);
  const [showLoader, setShowLoader] = React.useState(false);
  const [viewChatModal, setViewChatModal] = React.useState(false);
  const [initialPrompt, setInitialPrompt] = React.useState("");

  const descriptionStyle = {
    minWidth: "100%",
    minHeight: "200px",
  };
  const zindex = {
    zIndex: "9999",
  };
  const ellipsisStyle = {
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    width: "300px",
  };
  const noMargin = {
    margin: 0,
  };

  const fetchArchivedMessageManifest = async (param) => {
    try {
      setShowLoader(true);
      const response = await API.graphql(
        graphqlOperation(getArchivedMessageManifest, param)
      );
      if (response.data?.getArchivedMessageManifest?.success) {
        const message = response.data.getArchivedMessageManifest.body;
        setManifestDetails({...message, message_bundle_details: message.message_bundle_details ? {
          attachment_path: message.message_bundle_details.attachment_path,
          message_path: message.message_bundle_details.message_path,
          metadata_path: message.message_bundle_details.metadata_path
        } : null,
        flat_message_details: message.flat_message_details ? {
          attachment_path: message.flat_message_details.attachment_path,
          message_path: message.flat_message_details.message_path,
          metadata_path: message.flat_message_details.metadata_path
        } : null,});
        setConnectorData(message.connector_details);

        notify("success");
      } else {
        console.error(response.data?.getArchivedMessageManifest?.message);
        notify("danger");
        history.goBack();
      }
      return response.data?.getArchivedMessageManifest?.success;
    } catch (error) {
      console.error(error);
      notify("danger");
      history.goBack();
    } finally {
      setShowLoader(false);
    }
  };

  useEffect(() => {
    async function fetchData() {
      setShowLoader(true);
      const parameters = {
        clientEnvironmentId: clientEnvironmentId,
        channelId: channelId,
        messageId: messageId,
        manifestId: manifestId,
        dateRollup: dateRollup,
      };
      const isSuccess = await fetchArchivedMessageManifest(parameters);
      if (!isSuccess) {
        notify("danger");
        history.goBack();
      }
    }
    fetchData();
  }, []);

  const reprocessMessage = async () => {
    try {
      notify("info");

      // Create the preparation data payload as specified
      const preparationData = {
        messages: [
          {
            msg_id: manifestDetails.msg_id,
            is_bundle: manifestDetails.is_bundle,
            date_rollup: manifestDetails.date_rollup,
            manifest_id: manifestDetails.manifest_id,
            archive_bundle_path: manifestDetails.archive_bundle_path,
            flat_message_details: manifestDetails.flat_message_details,
            message_bundle_details: manifestDetails.message_bundle_details,
          }
        ],
        channel_id: channelId,
      };

      // Create the invokeMCTask payload
      const taskPayload = {
        client_id: clientId,
        client_environment_id: clientEnvironmentId,
        subject: "mccarchive",
        task_type: "resendmessages",
        mcc_preparation_data: JSON.stringify(preparationData),
        mc_task_data: null,
        mcc_cleanup_data: null,
        needs_preparation: true,
        needs_cleanup: true,
      };

      setShowLoader(true);

      const response = await API.graphql(
        graphqlOperation(invokeMCTask, taskPayload)
      );

      if (response.data?.invokeMCTask?.success) {
        notify(
          "success",
          `Reprocess task created successfully. Task ID: ${response.data.invokeMCTask.body?.task_id}`
        );
      } else {
        console.error(response.data?.invokeMCTask?.message);
        notify("danger", "Failed to create reprocess task");
      }
    } catch (error) {
      console.error(error);
      notify("danger", "An error occurred while creating the reprocess task");
    } finally {
      setShowLoader(false);
    }
  };

  const [alert, setAlert] = React.useState(null);

  const hideAlert = () => {
    setAlert(null);
  };

  if (showLoader) return <Spinner animation="grow" />;
  return (
    <>
      {alert}
      <Container fluid>
        <Row>
          <Col>
            <h2>Message Details</h2>
          </Col>
          {currentUser.groupName === "external" && (
            <Col className="my-auto text-right">
              <Button
                variant="secondary"
                className="btn-outline"
                onClick={() => {
                  setSteps(tourGuideSteps);
                  setCurrentStep(0);
                  setIsOpen(true);
                }}
              >
                <i className="fas fa-desktop"></i> View Our Tour Guide
              </Button>
            </Col>
          )}
        </Row>
        <Card id="client-details-card">
          <Card.Body>
            <Row>
              <Col md="12">
                <h3>Client Details</h3>
                <p style={noMargin}>Client Name: {clientName}</p>
                <p style={noMargin}>
                  Environment Name: {clientEnvironmentName}
                </p>
                <p style={noMargin}>Channel Name: {channelName}</p>
                <p style={noMargin}>
                  Message Received Date:{" "}
                  {convertDateToLocaleString(manifestDetails.date_received)}
                </p>
                <p style={noMargin}>
                  Message Completed Date:{" "}
                  {convertDateToLocaleString(manifestDetails.date_completed)}
                </p>
                <p style={noMargin}>Message Id: {manifestDetails.msg_id}</p>
                <p style={noMargin}>
                  Size In Bytes: {manifestDetails.raw_message_bytes}
                </p>
              </Col>
            </Row>
          </Card.Body>
        </Card>
        <Card>
          <Card.Body>
            <Row>
              <Col md="12" id="connector-details">
                <h3>Connector Details</h3>
                {connectorData && connectorData.length > 0 && (
                  <>
                    <Table className="table-hover table-striped w-full">
                      <thead>
                        <tr>
                          <th>Connector ID</th>
                          <th>Connector Name</th>
                          <th>Connector Message Status</th>
                          <th>Connector Error Text</th>
                        </tr>
                      </thead>
                      <tbody>
                        {connectorData.map((connector, key) => {
                          return (
                            <tr key={key}>
                              <td>{connector.connector_id}</td>
                              <td>{connector.connector_name}</td>
                              <td>{connector.connector_status}</td>
                              <td>
                                {
                                  <OverlayTrigger
                                    key={`event-type-${connector.connector_id}`}
                                    placement="right"
                                    overlay={
                                      <Tooltip
                                        id={`event-type-tooltip-${connector.connector_id}`}
                                        style={zindex}
                                      >
                                        {connector.connector_error_text}
                                      </Tooltip>
                                    }
                                  >
                                    <div style={ellipsisStyle}>
                                      {connector.connector_error_text
                                        ? connector.connector_error_text
                                        : ""}
                                    </div>
                                  </OverlayTrigger>
                                }
                              </td>
                              <td>
                                {connector.connector_status === "ERROR" && (
                                  <Button
                                    variant="primary"
                                    className="btn-outline"
                                    onClick={() => {
                                      setInitialPrompt(
                                        `Can you help me fix this Mirth Connect channel error?\n${connector.connector_error_text}`
                                      );
                                      setViewChatModal(true);
                                    }}
                                  >
                                    Mirth Assist
                                  </Button>
                                )}
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </Table>
                  </>
                )}
              </Col>
            </Row>
          </Card.Body>
        </Card>
        {manifestDetails.raw_data.message !== undefined && manifestDetails.raw_data.message !== null && (
        <Card>
          <Card.Body>
            <h3>Message</h3>
            <Row>
              <Col md="12" id="message-details">
                <textarea
                  id="messageDescription"
                  style={descriptionStyle}
                  disabled={true}
                  className="form-control"
                  value={manifestDetails.raw_data.message}
                ></textarea>
              </Col>
            </Row>
            <Row>
              <Col>
                <div style={{ float: "right", marginTop: "10px" }}>
                  <Button
                    id="reprocess-message-button"
                    className="btn-outline"
                    variant="primary"
                    style={{ marginLeft: "30px" }}
                    onClick={() => {
                      reprocessMessage();
                    }}
                  >
                    <i className="fas fa-redo-alt"></i> Reprocess Message
                  </Button>
                </div>
              </Col>
            </Row>
          </Card.Body>
        </Card>
        )}
        {manifestDetails.raw_data.attachment !== undefined && manifestDetails.raw_data.attachment !== null && (
        <Card>
          <Card.Body>
            <h3>Attachment</h3>
            <Row>
              <Col md="12" id="attachment-details">
                <textarea
                  id="attachmentDescription"
                  style={descriptionStyle}
                  disabled={true}
                  className="form-control"
                  value={manifestDetails.raw_data.attachment}
                ></textarea>
              </Col>
            </Row>
          </Card.Body>
        </Card>
        )}
        {manifestDetails.raw_data.metadata !== undefined && manifestDetails.raw_data.metadata !== null && (
        <Card>
          <Card.Body>
            <h3>Metadata</h3>
            <Row>
              <Col md="12" id="metadata-details">
                <textarea
                  id="metadataDescription"
                  style={descriptionStyle}
                  disabled={true}
                  className="form-control"
                  value={manifestDetails.raw_data.metadata}
                ></textarea>
              </Col>
            </Row>
          </Card.Body>
        </Card>
        )}
        <Modal
          toggle={() => setViewChatModal(!viewChatModal)}
          size="xl"
          isOpen={viewChatModal}
          scrollable={true}
        >
          <ModalHeader style={{ justifyContent: "center" }}>
            Mirth Assist
          </ModalHeader>
          <ModalBody>
            <Chat
              clientId={clientId}
              clientEnvironmentId={clientEnvironmentId}
              channelId={channelId}
              inboundMessageIdempotencyKey={null}
              initialPrompt={initialPrompt}
            />
          </ModalBody>
          <ModalFooter style={{ justifyContent: "center" }}>
            <Button
              variant="secondary"
              style={{ marginRight: "10px" }}
              onClick={() => {
                setViewChatModal(false);
              }}
            >
              Cancel
            </Button>
          </ModalFooter>
        </Modal>
      </Container>
    </>
  );
};

export default ViewMessage;
